var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton } from '@claims-ia/design-system';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import FileCollectionUpload from '@declaration/components/upload/FileCollectionUpload.vue';
import AmountInput from '@declaration/components/UI/AmountInput.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { ClaimTypeTrigram, } from '@shared/types/api/claim';
import { GLASS_BREAKAGE_ROOM_DAMAGE_REPARATION_BY_CHOICES } from '@shared/constants/glassBreakageDamageConstants';
import { GLASS_BREAKAGE_ROOM_DAMAGE_REPARATIONS_BY_ANSWERS, GLASS_BREAKAGE_ROOM_DAMAGE_REPARATIONS_ANSWERS, GLASS_BREAKAGE_TRAD_KEYS, } from '@declaration/constants/glassBreakageDamageConstants';
import { GlassBreakageRoomDamageReparationBy } from '@shared/types/api/glassBreakageDamage';
import { ClaimFileType } from '@shared/types/file';
import { newValidator, validate } from '@shared/validator/validator';
import { ValidationContext } from '@shared/validator/validationContext';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
import { ApiEntityType } from '@shared/types/api/apiEntityType';
import { newClientIdentifier as newTempId } from '@shared/utils/clientIdentifier';
const claim = namespace('claim');
const counting = namespace('counting');
const qualification = namespace('qualification');
const settings = namespace('settings');
const DEFAULT_MAX_REPAIRS = 1;
let GlassDamagesReparationsMultipleInvoicesQuestion = class GlassDamagesReparationsMultipleInvoicesQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.validators = {};
        this.validator = null;
        this.selectedRepairDraft = null;
        this.repairDrafts = {};
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get repairDraftList() {
        return Object.values(this.repairDrafts);
    }
    created() {
        var _a, _b, _c, _d;
        const backendRepairs = (_a = this.qualification.glassBreakageDamageReparationInvoices) !== null && _a !== void 0 ? _a : [];
        if (backendRepairs.length > 0) {
            // Hydratation depuis le backend
            this.initRepairDraftsFromBackend(backendRepairs);
        }
        const drafts = (_b = this.repairDraftList) !== null && _b !== void 0 ? _b : [];
        // GARANTIE UX : toujours au moins un draft
        if (drafts.length === 0) {
            this.addRepairDraft();
        }
        this.validator = newValidator({
            fileCollection: (_c = this.selectedRepairDraft) === null || _c === void 0 ? void 0 : _c.fileCollection,
            amount: (_d = this.selectedRepairDraft) === null || _d === void 0 ? void 0 : _d.amount,
        });
        const draft = drafts[0];
        if (draft) {
            this.selectedRepairDraft = draft;
        }
    }
    fieldErrors(fieldName, draft) {
        var _a;
        if (draft.tempId !== ((_a = this.selectedRepairDraft) === null || _a === void 0 ? void 0 : _a.tempId))
            return [];
        return this.validation.fieldErrors(fieldName, this);
    }
    fieldIsValid(fieldName, draft) {
        var _a;
        if (draft.tempId !== ((_a = this.selectedRepairDraft) === null || _a === void 0 ? void 0 : _a.tempId))
            return true;
        return this.validation.fieldIsValid(fieldName);
    }
    get nonEmptyRepairDraftsCount() {
        var _a;
        const drafts = (_a = this.repairDraftList) !== null && _a !== void 0 ? _a : [];
        return drafts.filter(this.hasFileCollection).length;
    }
    get maxRepairs() {
        var _a, _b, _c, _d, _e;
        return ((_e = (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.maxRepairs) === null || _d === void 0 ? void 0 : _d[this.claimTypeTrigram]) !== null && _e !== void 0 ? _e : DEFAULT_MAX_REPAIRS);
    }
    get hasReachedMaxRepairs() {
        return this.nonEmptyRepairDraftsCount > this.maxRepairs;
    }
    get canAddNewRepairDraft() {
        return !this.hasReachedMaxRepairs;
    }
    get typeTrigram() {
        var _a;
        return (_a = this.claimTypeTrigram) !== null && _a !== void 0 ? _a : undefined;
    }
    get hasDisableDamagesJustificatives() {
        return insurerHasFeature(InsurerFeatureFlag.DisableDamagesJustificatives);
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink, this.typeTrigram);
    }
    get showHelpLink() {
        var _a, _b, _c, _d;
        if (this.hideHelpLink &&
            ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.roomDamageReparations) === null || _d === void 0 ? void 0 : _d.showHelpLink) === false) {
            return false;
        }
        return true;
    }
    get validation() {
        var _a, _b;
        validate(this.validator, {
            fileCollection: (_a = this.selectedRepairDraft) === null || _a === void 0 ? void 0 : _a.fileCollection,
            amount: (_b = this.selectedRepairDraft) === null || _b === void 0 ? void 0 : _b.amount,
        }, {
            amount: {
                presence: {
                    allowEmpty: false,
                    message: GLASS_BREAKAGE_TRAD_KEYS['room-damage-reparation-invoice-question-upload-validation'],
                },
            },
            fileCollection: {
                requiredFileCollection: this.selectedReparationByValue === GlassBreakageRoomDamageReparationBy.Professional
                    ? {
                        message: 'validator.requiredFileCollection',
                        trigram: ClaimTypeTrigram.Glass,
                    }
                    : null,
            },
        });
        return new ValidationContext(this.validator);
    }
    shouldDisplayAddInvoiceButton(index) {
        return this.nonEmptyRepairDraftsCount < this.maxRepairs || index < this.maxRepairs;
    }
    shouldDisplayReparationInvoiceAmount(draft) {
        // Règle globale : plus de saisie si limite atteinte
        if (this.hasReachedMaxRepairs) {
            return false;
        }
        switch (this.selectedReparationByValue) {
            case GlassBreakageRoomDamageReparationBy.Professional:
                // Toujours affiché
                return true;
            case GlassBreakageRoomDamageReparationBy.Myself:
                // Affiché uniquement si la facture existe
                return draft.fileCollection !== null && draft.fileCollection.uploadedAppFiles.length > 0;
            default:
                return false;
        }
    }
    get panelTitle() {
        return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['room-damage-reparation-type-panel-title']);
    }
    get sidebarTitle() {
        const key = GLASS_BREAKAGE_TRAD_KEYS['room-damage-reparation-type-question-sidebar_title'];
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get reparationByQuestionTitle() {
        return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['room-damage-reparation-by-question']);
    }
    get reparationInvoiceQuestionTitle() {
        if (!this.selectedReparationByValue)
            return null;
        return this.isReparationInvoiceMandatory
            ? this.$tc(GLASS_BREAKAGE_TRAD_KEYS['room-damage-reparation-mandatory-invoice-question'])
            : this.$tc(GLASS_BREAKAGE_TRAD_KEYS['room-damage-reparation-optional-invoice-question']);
    }
    get reparationInvoiceQuestionDescription() {
        return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['room-damage-reparation-invoice-question-description']);
    }
    get reparationAddInvoiceLabel() {
        return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['room-damage-reparation-invoice-question-upload']);
    }
    get reparationChoices() {
        return YES_OR_NO_CHOICES;
    }
    get reparationByChoices() {
        return GLASS_BREAKAGE_ROOM_DAMAGE_REPARATION_BY_CHOICES;
    }
    get selectedReparationValue() {
        return this.qualification.roomDamageReparations;
    }
    get selectedReparationByValue() {
        return this.qualification.roomDamageReparationsBy;
    }
    get shouldDisplayReparationBy() {
        return this.selectedReparationValue === true;
    }
    get shouldDisplayReparationInvoice() {
        return (this.selectedReparationValue === true &&
            this.selectedReparationByValue !== null &&
            this.selectedReparationByValue !== GlassBreakageRoomDamageReparationBy.Assistance);
    }
    get isReparationInvoiceMandatory() {
        return this.selectedReparationByValue === GlassBreakageRoomDamageReparationBy.Professional;
    }
    get canValidateInvoice() {
        var _a;
        const drafts = (_a = this.repairDraftList) !== null && _a !== void 0 ? _a : [];
        // On ne considère que les drafts "réels"
        const nonEmptyDrafts = drafts.filter(this.hasFileCollection);
        // S'il n'y a aucun draft réel
        if (nonEmptyDrafts.length === 0) {
            if (this.isReparationInvoiceMandatory)
                return false;
            return true;
        }
        // Chaque draft non vide doit être valide
        return nonEmptyDrafts.every((draft) => {
            const filesCount = draft.fileCollection.uploadedAppFiles.length;
            const hasFiles = filesCount > 0;
            const isAmountFilled = !!draft.amount;
            if (!this.hasDisableDamagesJustificatives) {
                if (this.isReparationInvoiceMandatory && !hasFiles)
                    return false;
                if (hasFiles && !isAmountFilled)
                    return false;
            }
            // Cas justificatifs désactivés
            if (this.hasDisableDamagesJustificatives &&
                this.shouldDisplayReparationInvoiceAmount(draft) &&
                !isAmountFilled) {
                return false;
            }
            return true;
        });
    }
    get invoiceFileType() {
        return ClaimFileType.CraftsmanInvoice;
    }
    get answer() {
        if (this.selectedReparationValue === null)
            return null;
        if (this.selectedReparationValue === false) {
            return this.$tc(GLASS_BREAKAGE_ROOM_DAMAGE_REPARATIONS_ANSWERS.no);
        }
        if (this.selectedReparationByValue === null)
            return null;
        return `${this.$tc(GLASS_BREAKAGE_ROOM_DAMAGE_REPARATIONS_ANSWERS.yes)}&nbsp;${this.$tc(GLASS_BREAKAGE_ROOM_DAMAGE_REPARATIONS_BY_ANSWERS[this.selectedReparationByValue])}`;
    }
    repairToDraft(repair) {
        var _a;
        // Si l'objet backend n'a pas encore d'id (facture nouvellement créée),
        // on génère un tempId avec UUID v4
        const tempId = (_a = repair.id) !== null && _a !== void 0 ? _a : newTempId();
        return {
            tempId,
            fileCollection: repair.invoice,
            amount: repair.invoiceAmount,
        };
    }
    initRepairDraftsFromBackend(repairs) {
        this.repairDrafts = {};
        repairs.forEach((repair) => {
            const draft = this.repairToDraft(repair);
            this.$set(this.repairDrafts, draft.tempId, draft);
        });
    }
    // ajouter un draft
    addRepairDraft() {
        const tempId = newTempId();
        this.$set(this.repairDrafts, tempId, {
            tempId,
            fileCollection: null,
            amount: null,
        });
        return tempId;
    }
    // maj d’un draft
    updateRepairDraft(tempId, patch) {
        const draft = this.repairDrafts[tempId];
        if (!draft)
            return;
        Object.assign(draft, patch);
    }
    // supprimer un draft
    removeRepairDraft(tempId) {
        this.$delete(this.repairDrafts, tempId);
        this.updateSelectedRepairDraft(tempId);
    }
    draftToRepairPayload(draft) {
        // Si le tempId est un IRI valide (i.e. commence par /api/), on l'utilise comme id
        // Sinon c'est un UUID généré localement et on passe null
        const id = draft.tempId.startsWith('/api/') ? draft.tempId : null;
        return {
            id,
            invoice: draft.fileCollection,
            invoiceAmount: draft.amount,
            '@type': ApiEntityType.GlassBreakageDamageInvoice,
        };
    }
    onReparationUpdate(roomDamageReparations) {
        if (roomDamageReparations === false) {
            this.updateAndSaveGlassBreakageDamageQualification({
                step: this.step,
                qualificationPayload: {
                    roomDamageReparations,
                    roomDamageReparationsBy: null,
                },
            });
        }
        else {
            this.updateGlassBreakageDamageQualification({
                qualificationPayload: { roomDamageReparations },
            });
        }
    }
    onReparationByUpdate(roomDamageReparationsBy) {
        if (roomDamageReparationsBy === GlassBreakageRoomDamageReparationBy.Assistance) {
            this.updateAndSaveGlassBreakageDamageQualification({
                step: this.step,
                qualificationPayload: {
                    roomDamageReparations: true,
                    roomDamageReparationsBy,
                },
            });
        }
        else {
            this.updateGlassBreakageDamageQualification({
                qualificationPayload: { roomDamageReparationsBy },
            });
        }
    }
    ensureEmptyDraftExists() {
        const drafts = this.repairDraftList;
        const hasEmptyDraft = drafts.some((d) => d.fileCollection === null || d.fileCollection.uploadedAppFiles.length === 0);
        if (hasEmptyDraft)
            return;
        if (!this.canAddNewRepairDraft)
            return;
        this.addRepairDraft();
    }
    onFileCollectionUpdate(tempId, fileCollection) {
        // update du draft
        this.updateRepairDraft(tempId, { fileCollection });
        // on met à jour le draft selectionné
        this.updateSelectedRepairDraft(tempId);
        // si la collection est vide => on supprime ce draft
        if (fileCollection.uploadedAppFiles.length === 0) {
            this.removeRepairDraft(tempId);
            return;
        }
        // si on vient d'ajouter des fichiers, on s'assure qu'il existe un draft vide
        this.ensureEmptyDraftExists();
    }
    onRoomDamageReparationsInvoiceAmountUpdate(roomDamageReparationsInvoiceAmount) {
        this.updateGlassBreakageDamageQualification({
            qualificationPayload: { roomDamageReparationsInvoiceAmount },
        });
    }
    onInvoiceAmountUpdate(tempId, amount) {
        this.updateRepairDraft(tempId, { amount });
        this.updateSelectedRepairDraft(tempId);
    }
    updateSelectedRepairDraft(tempId) {
        var _a;
        this.selectedRepairDraft = (_a = this.repairDrafts[tempId]) !== null && _a !== void 0 ? _a : null;
    }
    hasFileCollection(draft) {
        return draft.fileCollection !== null && draft.fileCollection.uploadedAppFiles.length > 0;
    }
    onValidate() {
        if (this.canValidateInvoice) {
            const validRepairsPayload = this.repairDraftList
                .filter(this.hasFileCollection)
                .map(this.draftToRepairPayload);
            this.updateAndSaveGlassBreakageDamageQualification({
                step: this.step,
                qualificationPayload: {
                    roomDamageReparations: this.selectedReparationValue,
                    roomDamageReparationsBy: this.selectedReparationByValue,
                    glassBreakageDamageReparationInvoices: validRepairsPayload,
                },
            });
        }
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], GlassDamagesReparationsMultipleInvoicesQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    claim.Action('saveClaimWithPayload')
], GlassDamagesReparationsMultipleInvoicesQuestion.prototype, "saveClaimWithPayload", void 0);
__decorate([
    counting.State('counting')
], GlassDamagesReparationsMultipleInvoicesQuestion.prototype, "counting", void 0);
__decorate([
    qualification.State('typeTrigram')
], GlassDamagesReparationsMultipleInvoicesQuestion.prototype, "claimTypeTrigram", void 0);
__decorate([
    qualification.State('qualification')
], GlassDamagesReparationsMultipleInvoicesQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], GlassDamagesReparationsMultipleInvoicesQuestion.prototype, "updateGlassBreakageDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], GlassDamagesReparationsMultipleInvoicesQuestion.prototype, "updateAndSaveGlassBreakageDamageQualification", void 0);
__decorate([
    settings.Getter('setting')
], GlassDamagesReparationsMultipleInvoicesQuestion.prototype, "setting", void 0);
GlassDamagesReparationsMultipleInvoicesQuestion = __decorate([
    Component({
        components: {
            UiButton,
            RadioPrimaryButton,
            QuestionPanel,
            FileCollectionUpload,
            AmountInput,
        },
        props: QuestionProps,
    })
], GlassDamagesReparationsMultipleInvoicesQuestion);
export default GlassDamagesReparationsMultipleInvoicesQuestion;
